import { render, staticRenderFns } from "./TransporterLRFQRequestAccept.vue?vue&type=template&id=3fca73a6"
import script from "./TransporterLRFQRequestAccept.vue?vue&type=script&lang=js"
export * from "./TransporterLRFQRequestAccept.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports